import React from "react"
import styled from "styled-components"
import media from "../../styles/media"
import PropTypes from "prop-types"

const Wrapper = styled.div`
  color: ${props => props.theme.black};
  grid-column: span 4;

  padding: 13px 0;
  border-top: 1px solid ${props => props.theme.black};
  border-bottom: 1px solid ${props => props.theme.black};
  min-width: 0;

  ${media.tablet`
    grid-column: span 12;
  `}
`
const Quote = styled.div`
  text-align: left;
  letter-spacing: 0;
  font-size: 25px;
  font-family: StanleyRegular, serif;

  ${media.desktop`
    font-size:40px;
    margin-bottom: 32px;
  `}
`
const Author = styled.div`
  margin-top: 15px;
  color: ${props => props.theme.lightGrey3};
`
export const ArtistQuote = ({ quote, author }) => {
  function replaceQuotes() {
    const chars = quote.trim().split("")

    if (chars[0] === `"`) {
      chars[0] = "&ldquo;"
    }

    if (chars[chars.length - 1] === `"`) {
      chars[chars.length - 1] = "&rdquo;"
    }

    const newString = chars.join("")

    return newString
  }
  return (
    <Wrapper>
      <Quote dangerouslySetInnerHTML={{ __html: replaceQuotes({ quote }) }} />
      <Author>{author}</Author>
    </Wrapper>
  )
}

ArtistQuote.propTypes = {
  quote: PropTypes.string,
  author: PropTypes.string,
}
